import { createBrowserRouter } from 'react-router-dom';
import { ROUTES } from '../consts/routes';
import { Layout } from '../pages/Layout';
import { ErrorPage } from '../pages/ErrorPage';
import { RequireAuthenticated } from './RequireAuthenticated';
import { LoadingPlansPage } from '../pages/LoadingPlansPage';
import { CreateLoadingPlanPage } from '../pages/CreateLoadingPlanPage';
import { ViewLoadingPlanPage } from '../pages/ViewLoadingPlanPage';
import { ViewSharedLoadingPlanPage } from '../pages/ViewSharedLoadingPlanPage';
import { HandPartsInclusionPage } from '../pages/HandPartsInclusionPage';
import { AuthTestPage } from '../pages/AuthTestPage/AuthTestPage';

const router = createBrowserRouter([
  {
    path: ROUTES.home,
    element: <Layout />,
    errorElement: <ErrorPage />,
    children: [
      {
        index: true,
        element: (
          // <RequireAuthenticated>
          <LoadingPlansPage />
          // </RequireAuthenticated>
        ),
      },
      {
        path: ROUTES.createLoadingPlan,
        element: (
          // <RequireAuthenticated>
          <CreateLoadingPlanPage />
          // </RequireAuthenticated>
        ),
      },
      {
        path: ROUTES.updateLoadingPlan,
        element: (
          // <RequireAuthenticated>
          <CreateLoadingPlanPage />
          // </RequireAuthenticated>
        ),
      },
      {
        path: ROUTES.viewLoadingPlan,
        element: (
          // <RequireAuthenticated>
          <ViewLoadingPlanPage />
          // </RequireAuthenticated>
        ),
      },
      {
        path: ROUTES.handPartsInclusion,
        element: (
          // <RequireAuthenticated>
          <div>{process.env.REACT_APP_IS_HAND_PARTS_INCLUSION_ENABLED === 'true' ? <HandPartsInclusionPage /> : <ErrorPage />}</div>
          // </RequireAuthenticated>
        ),
      },
      {
        path: ROUTES.sharedViewLoadingPlan,
        element: <ViewSharedLoadingPlanPage />,
      },
      {
        path: ROUTES.authTest,
        element: <RequireAuthenticated><AuthTestPage /></RequireAuthenticated>,
      }
    ]
  },
])

export default router;
